"use client"

import type { ComponentPropsWithoutRef } from "react"
import { formatPhone } from "@/lib/utils/phone"

export interface PhoneInputProps
  extends Omit<ComponentPropsWithoutRef<"input">, "value" | "onChange" | "type"> {
  value: string
  onChange: (value: string) => void
}

/** US phone field: live (XXX) XXX-XXXX mask + tel keyboard + autofill hint. */
export function PhoneInput({
  value,
  onChange,
  placeholder,
  autoComplete,
  ...rest
}: PhoneInputProps) {
  return (
    <input
      {...rest}
      type="tel"
      inputMode="tel"
      autoComplete={autoComplete ?? "tel"}
      maxLength={14}
      placeholder={placeholder ?? "(555) 000-0000"}
      value={value}
      onChange={(e) => onChange(formatPhone(e.target.value))}
    />
  )
}
